import { AnimatedModal, Button } from 'components'
import programmer_img from 'features/AlgoEditor/assets/programmer.svg'
import { useRouter } from 'next/router'
import React from 'react'
import { setLoginModalOpen, useAlgoEditorState, useAppDispatch } from 'state'

import { XIcon } from '@heroicons/react/solid'

function LoginEditorModal() {
  const router = useRouter()
  const { loginModalOpen } = useAlgoEditorState()
  const dispatch = useAppDispatch()

  const onClose = () => dispatch(setLoginModalOpen(false))

  return (
    <AnimatedModal isOpen={loginModalOpen} onClose={onClose}>
      <div className="w-full px-6 py-2 text-white bg-zinc-800 rounded-lg w-[500px] flex flex-col justify-center">
        <div className="flex flex-row justify-between items-center pb-2">
          <div className="text-lg font-medium my-2">Login To Continue</div>

          <Button variant="transparent" className="p-0" onClick={onClose}>
            <XIcon className="h-7 w-7" />
          </Button>
        </div>

        <div className="flex items-stretch mt-2 mb-5">
          <div className="w-full md:w-2/5 mb-2 md:mb-0 md:mr-2 flex justify-center items-center">
            <img
              className="w-full h-auto max-h-36"
              src={programmer_img.src}
              alt=""
            />
          </div>

          <div className="flex flex-col justify-center items-center py-2">
            <p className="py-3 text-lg mb-2">
              Please login to submit solutions!
            </p>

            <Button
              variant="primary"
              onClick={() => router.push(`/login?redirect=${router.asPath}`)}>
              Get started
            </Button>
          </div>
        </div>
      </div>
    </AnimatedModal>
  )
}

export default LoginEditorModal
